var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container p-3 bg-white shadow border-radius--bottom" },
    [
      _c(
        "div",
        { staticClass: "row w-100 m-0" },
        _vm._l(_vm.rowElements, function(row) {
          return _c(
            "div",
            {
              key: row.icon,
              staticClass: "col-12 row-card",
              class: row.click == null ? "pointer-none" : ""
            },
            [
              _c("Link", {
                staticClass: "body-1 hovered bord-bott mb-2 mt-2",
                attrs: {
                  color: "none",
                  "color-icon": "orange",
                  icon: row.icon,
                  text: row.text != undefined ? row.text : "",
                  "with-border": false
                },
                on: {
                  click: function($event) {
                    return _vm.$eventHandler(row.click)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm.$slots["section-middle"]
        ? _c("div", { staticClass: "row w-100 m-0 mb-2" }, [
            _c("div", { staticClass: "col-12" }, [_vm._t("section-middle")], 2)
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row w-100 m-0" },
        _vm._l(_vm.rowActions, function(action) {
          return _c(
            "div",
            { key: action.icon, staticClass: "col-12 row-card" },
            [
              _c("Link", {
                staticClass: "body-1 hovered bord-bott mb-2 mt-2",
                attrs: {
                  icon: action.icon,
                  text: action.text != undefined ? action.text : ""
                },
                on: {
                  click: function($event) {
                    return _vm.$eventHandler(action.click)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "row w-100 m-0 mt-2" }, [
        _c("div", { staticClass: "col-12" }, [_vm._t("section-bottom")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }